import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CookieConsentBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/app/src/context/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/tailwind.css");
